import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PageService } from 'src/app/core/page/page.service';
import { selectActiveLanguage } from 'src/app/store/language/selectors';
import { AppStateInterface } from 'src/app/store/types';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { AsyncPipe } from '@angular/common';
import { CapitalizePipe } from 'src/app/core/custom-pipes/capitalize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { heroQuestionMarkCircle } from '@ng-icons/heroicons/outline';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    imports: [
        NgIcon,
        ReactiveFormsModule,
        AsyncPipe,
        CapitalizePipe,
        TranslateModule,
    ],
    providers: [provideIcons({ heroQuestionMarkCircle })]
})
export class FaqComponent implements OnInit {
  activeLanguageSubscription!: Subscription;
  faqData: any = [];
  languageDirection: string = 'ltr';
  succesfullyAskedQuestion: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  faqForm = new FormGroup({
    question: new FormControl<string | null>(null, [Validators.required]),
  });

  constructor(
    private _store: Store<AppStateInterface>,
    private _pageService: PageService,
  ) {}

  ngOnInit() {
    this.activeLanguageSubscription = this._store
      .select(selectActiveLanguage)
      .subscribe((language: string) => {
        this.languageDirection =
          this._pageService.getLanguageDirection(language);
        this._pageService.getFAQData(language).subscribe((data: any) => {
          this.faqData = data.data;
        });
      });
      this.succesfullyAskedQuestion.next(false);
  }

  ngOnDestroy() {
    if (this.activeLanguageSubscription) {
      this.activeLanguageSubscription.unsubscribe();
    }
  }

  onFormSubmit(){
    const question = this.faqForm.get('question')?.value
    if(question){
      const dto = {
        question: question
      }
      this._pageService.askFaqQuestion(dto).subscribe({
        next: result => {
          this.succesfullyAskedQuestion.next(true);
          this.faqForm.reset()
        },
        error: error => {

        }
      })
    }
  }
}
